import { useState, useEffect, useRef } from 'react'

export const useCalculateInputVolume = (localAudioTrack, participantMuted: boolean) => {

  const [ currentVolume, setCurrentVolume ] = useState(0)
  const requestRef = useRef(0)

  useEffect(() => {

    if (participantMuted && localAudioTrack) {

      if (localAudioTrack === null) return

      const createStreamAndMeasureAudioLevel = () => {

        const audioContext = new AudioContext()
        const analyserNode = audioContext.createAnalyser()

        const stream = new MediaStream([localAudioTrack.mediaStreamTrack])
        const mediaStreamAudioSourceNode = audioContext.createMediaStreamSource(stream)

        mediaStreamAudioSourceNode.connect(analyserNode)

        const pcmData = new Float32Array(analyserNode.fftSize)

        const onFrame = () => {

          analyserNode.getFloatTimeDomainData(pcmData)

          let sumSquares = 0.0
          for (const amplitude of pcmData) { sumSquares += amplitude * amplitude }

          if (localAudioTrack.mediaStreamTrack.readyState === "live") {

            setCurrentVolume(Math.sqrt(sumSquares / pcmData.length) * 1000)

            requestRef.current = window.requestAnimationFrame(onFrame)

          }

        }

        return onFrame

      }

      requestRef.current = window.requestAnimationFrame(createStreamAndMeasureAudioLevel())

    }

    return () => window.cancelAnimationFrame(requestRef.current)

  }, [ localAudioTrack, participantMuted ])

  return { currentVolume }

}

export default useCalculateInputVolume